import { useState } from 'react';
import { Button, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { RightCircleFilled } from '@ant-design/icons';

export default function ContactForm() {

  const [result, setResult] = useState("");
  const [position] = useState('end');

  const onSubmit = async (event) => {

    event.preventDefault();

    setResult("Sending...");

    const formData = new FormData(event.target);

    // Your Web3Forms Access Key
    formData.append(
      "access_key",
      "bd1ba844-4cd2-461f-9bd1-68f40813538d"
    );

    try {

      const response = await fetch(
        "https://api.web3forms.com/submit",
        {
          method: "POST",
          body: formData
        }
      );

      const data = await response.json();

      console.log("Web3Forms Response:", data);

      if (data.success) {

        setResult(" Form Submitted Successfully ");

        event.target.reset();

      } else {

        setResult(data.message || "Error Sending Form");

      }

    } catch (error) {

      console.log("Submission Error:", error);

      setResult("Something went wrong!");

    }

  };

  return (

    <form onSubmit={onSubmit} autoComplete="off">

      <div className='contact-form-style'>

        <Input
          type="text"
          name="first_name"
          placeholder="Enter your First Name"
          required
          size="large"
          style={{
            height: "50px"
          }}
        />

        <Input
          type="text"
          name="last_name"
          placeholder="Enter your Last Name"
          size="large"
          style={{
            height: "50px"
          }}
        />

      </div>

      <div
        className='contact-form-style'
        style={{
          marginTop: "1rem"
        }}
      >

        <Input
          type="text"
          name="contact_number"
          placeholder="Enter your Phone"
          size="large"
          style={{
            height: "50px"
          }}
        />

        <Input
          type="email"
          name="email"
          placeholder="Enter your Email"
          required
          size="large"
          style={{
            height: "50px"
          }}
        />

      </div>

      <div
        style={{
          marginTop: "1rem"
        }}
      >

        <TextArea
          name="message"
          rows={4}
          placeholder="Message"
          required
        />

      </div>

      <div
        style={{
          marginTop: "1.5rem"
        }}
      >
 <span
        style={{
          display: "block",
          marginTop: "1rem",
          color: "#000",
          fontSize:"1.2rem"
        }}
      >
        {result}
      </span>
        <Button
          htmlType="submit"
          className='contactsubmitbtn'
          icon={<RightCircleFilled />}
          iconPosition={position}
        >
          Submit
        </Button>

      </div>

     

    </form>

  );
}